module.exports = {
  "id": "break in half",
  "color": "red",
  "title": "break in half",
  "info": [
    {
      "text": "Split into two smaller copies when touched by another piece",
      "image": "provision/glitches/break in half/break in half.gif"
    }
  ],
  "icon": "division",
  "category": "destroy",
  "searchTags": ["split","brake","double","mini","two","2"],
  "exposedVariables": [
    {
      "spriteName": "$glitch_target",
      "variableName": "destroyer piece",
      "tooltip":"Set which piece causes the split",
      "input": {
        "type": "sprite",
        "options": [],
        "min": -999,
        "max": 999
      },
      "value": "none"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "times to split",
      "tooltip":"Set how many times the piece will split apart",
      "input": {
        "type": "slider",
        "options": [],
        "min": "1",
        "max": "5",
        "step": "1"
      },
      "value": "3"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "size change",
      "tooltip":"Set how much smaller the pieces will be after they split",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "1",
        "step": "0.05"
      },
      "value": "0.5"
    }

  ],
  "codeImage": "provision/glitches/balloon/balloon.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "isRemix": true
};